import { emptySplitApi as api } from '../../../store/emptyApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApiV1UnderwritingLookupsFields: build.query<
            GetApiV1UnderwritingLookupsFieldsApiResponse,
            GetApiV1UnderwritingLookupsFieldsApiArg
        >({
            query: () => ({ url: `/api/v1/underwriting/lookups/fields` }),
        }),
        getApiV1UnderwritingErrors: build.query<
            GetApiV1UnderwritingErrorsApiResponse,
            GetApiV1UnderwritingErrorsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/errors`,
                params: { StartDate: queryArg.startDate, EndDate: queryArg.endDate, ModelID: queryArg.modelId },
            }),
        }),
        getApiV1UnderwritingModels: build.query<
            GetApiV1UnderwritingModelsApiResponse,
            GetApiV1UnderwritingModelsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/models`,
                params: {
                    ModelID: queryArg.modelId,
                    Amount: queryArg.amount,
                    IsActive: queryArg.isActive,
                    ModelType: queryArg.modelType,
                },
            }),
        }),
        postApiV1UnderwritingModels: build.mutation<
            PostApiV1UnderwritingModelsApiResponse,
            PostApiV1UnderwritingModelsApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/underwriting/models`, method: 'POST', body: queryArg }),
        }),
        getApiV1UnderwritingModelsByModelId: build.query<
            GetApiV1UnderwritingModelsByModelIdApiResponse,
            GetApiV1UnderwritingModelsByModelIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/models/${queryArg.modelId}`,
                params: { history: queryArg.history },
            }),
        }),
        postApiV1UnderwritingModelsByModelId: build.mutation<
            PostApiV1UnderwritingModelsByModelIdApiResponse,
            PostApiV1UnderwritingModelsByModelIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/models/${queryArg.modelId}`,
                method: 'POST',
                body: queryArg.underwriteModel,
            }),
        }),
        deleteApiV1UnderwritingModelsByModelId: build.mutation<
            DeleteApiV1UnderwritingModelsByModelIdApiResponse,
            DeleteApiV1UnderwritingModelsByModelIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/underwriting/models/${queryArg}`, method: 'DELETE' }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiV1UnderwritingLookupsFieldsApiResponse = /** status 200 Success */ ApplicationField[];
export type GetApiV1UnderwritingLookupsFieldsApiArg = void;
export type GetApiV1UnderwritingErrorsApiResponse = /** status 200 Success */ ResultError[];
export type GetApiV1UnderwritingErrorsApiArg = {
    startDate?: string;
    endDate?: string;
    modelId?: number;
};
export type GetApiV1UnderwritingModelsApiResponse = /** status 200 Success */ UnderwriteModel[];
export type GetApiV1UnderwritingModelsApiArg = {
    modelId?: number;
    amount?: number;
    isActive?: boolean;
    modelType?: ModelType;
};
export type PostApiV1UnderwritingModelsApiResponse = /** status 200 Success */ UnderwriteModel;
export type PostApiV1UnderwritingModelsApiArg = UnderwriteModel;
export type GetApiV1UnderwritingModelsByModelIdApiResponse = /** status 200 Success */ UnderwriteModel;
export type GetApiV1UnderwritingModelsByModelIdApiArg = {
    modelId: number;
    history?: number;
};
export type PostApiV1UnderwritingModelsByModelIdApiResponse = /** status 200 Success */ UnderwriteModel;
export type PostApiV1UnderwritingModelsByModelIdApiArg = {
    modelId: number;
    underwriteModel: UnderwriteModel;
};
export type DeleteApiV1UnderwritingModelsByModelIdApiResponse = unknown;
export type DeleteApiV1UnderwritingModelsByModelIdApiArg = number;
export type ApplicationField = {
    name?: string | null;
    preReqId?: number | null;
};
export type ResultError = {
    modelID?: number;
    error?: string | null;
    createdOn?: string;
};
export type ModelType = 'Decision' | 'Deny' | 'Price' | 'Risk' | 'BidWinRate'| 'Conversion';
export type Symbol = 'GT' | 'GTE' | 'E' | 'LT' | 'LTE';
export type DataRobot = {
    project?: string | null;
    model?: string | null;
    deployment?: string | null;
    isLegacy: boolean;
};
export type DecisionModel = {
    acceptLimit?: number;
    acceptSymbol?: Symbol;
    denyLimit?: number;
    denySymbol?: Symbol;
    dataRobot?: DataRobot;
};
export type Operator = 'NONE' | 'AND' | 'OR';
export type DenyRule = {
    type?: string | null;
    key?: string | null;
    compareKey?: string | null;
    symbol?: Symbol;
    value?: string | null;
    operator?: Operator;
    notnull?:string;
    denyRules?: DenyRule[] | null;
};
export type PriceModel = {
    minAmount?: number;
    maxAmount?: number;
    slope?: number;
    intercept?: number;
    dataRobot?: DataRobot;
};
export type BidWinRateModel = {
    minAmount?: number;
    maxAmount?: number;
    dataRobot?: DataRobot;
}
export type ConversionModel = {
    minAmount?: number;
    maxAmount?: number;
    minValue?: number;
    dataRobot?: DataRobot;
  };
export type Range = {
    low?: number;
    high?: number;
};
export type RiskModel = {
    scoreModifier?: number;
    scoreMultiplier?: number;
    increment?: number;
    range?: Range;
    dataRobot?: DataRobot;
};
export type UnderwriteModel = {
    modelId: number;
    name: string;
    activeStart: string;
    activeEnd: string;
    isDeleted?: boolean;
    groupId?: number | null;
    groupWeight?: number | null;
    modelType: ModelType;
    lowAmount: number;
    highAmount: number;
    preReqs: number[];
    decision?: DecisionModel;
    denyRules?: DenyRule[] | null;
    price?: PriceModel;
    risk?: RiskModel;
    bidWinRate?: BidWinRateModel;
    conversion?:ConversionModel;
};
